// Greek translations (Ελληνικά)
export const el: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Πίνακας ελέγχου',
  'menu.orderNew': 'Καταχώριση προϊόντος',
  'menu.deliveryList': 'Λίστα παράδοσης',
  'menu.delivery': 'Παράδοση',
  'menu.receipt': 'Εκτύπωση απόδειξης/ετικέτας',
  
  // Definitions
  'menu.definitions': 'Ορισμοί',
  'menu.customers': 'Πελάτες',
  'menu.products': 'Ορισμοί προϊόντων',
  'menu.pricing': 'Ορισμοί τιμών',
  'menu.tailoring': 'Εργασίες ραπτικής',
  'menu.attributes': 'Χαρακτηριστικά προϊόντων',
  'menu.users': 'Χρήστες',
  'menu.productOrdering': 'Σειρά προϊόντων',
  'menu.discounts': 'Ορισμοί εκπτώσεων',
  
  // Settings
  'menu.settings': 'Ρυθμίσεις',
  'menu.generalSettings': 'Γενικές ρυθμίσεις',
  'menu.permissions': 'Διαχείριση δικαιωμάτων',
  'menu.subscription': 'Συνδρομή',
  'menu.invoices': 'Διαχείριση τιμολογίων',
  'menu.expenses': 'Καταχώριση εξόδων',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Αναφορές & Λογιστική',
  'menu.systemAndCommunication': 'Σύστημα & Επικοινωνία',
  'menu.reportsList': 'Λίστα αποδείξεων',
  'menu.accountStatement': 'Κατάσταση λογαριασμού',
  'menu.tickets': 'Αιτήματα υποστήριξης',
  'menu.support': 'Υποστήριξη',
  'menu.profile': 'Προφίλ',
  'menu.logout': 'Αποσύνδεση',
  'menu.notifications': 'Ειδοποιήσεις SMS/WhatsApp',
  'menu.whatsappConnection': 'Σύνδεση WhatsApp',
  'menu.smsConnection': 'Σύνδεση SMS',
  
  // Dashboard
  'dashboard.title': 'Πίνακας ελέγχου',
  'dashboard.todaySales': 'Σημερινές πωλήσεις',
  'dashboard.totalOrders': 'Σύνολο παραγγελιών',
  'dashboard.pendingDeliveries': 'Εκκρεμείς παραδόσεις',
  'dashboard.activeCustomers': 'Ενεργοί πελάτες',
  'dashboard.recentOrders': 'Πρόσφατες παραγγελίες',
  'dashboard.viewAll': 'Προβολή όλων',
  'dashboard.quickActions': 'Γρήγορες ενέργειες',
  'dashboard.newOrder': 'Νέα παραγγελία',
  'dashboard.newCustomer': 'Νέος πελάτης',
  'dashboard.deliveries': 'Παραδόσεις',
  'dashboard.reports': 'Αναφορές',
  'dashboard.today': 'Σήμερα',
  'dashboard.yesterday': 'Χθες',
  'dashboard.week': 'Εβδομάδα',
  'dashboard.month': 'Μήνας',
  'dashboard.quarter': 'Τρίμηνο',
  'dashboard.year': 'Έτος',
  'dashboard.totalRevenue': 'Συνολικά έσοδα',
  'dashboard.totalPieces': 'Σύνολο τεμαχίων',
  'dashboard.cancelled': 'Ακυρωμένα',
  'dashboard.inProcess': 'Σε επεξεργασία',
  'dashboard.inProcessDesc': 'Παραγγελίες σε επεξεργασία',
  'dashboard.ready': 'Έτοιμα',
  'dashboard.readyDesc': 'Έτοιμα προς παράδοση',
  'dashboard.delivered': 'Παραδόθηκαν',
  'dashboard.deliveredDesc': 'Ολοκληρωμένες παραγγελίες',
  'dashboard.announcements': 'Ανακοινώσεις',
  'dashboard.announcementAll': 'Γενικές',
  'dashboard.announcementPrivate': 'Προσωπικές',
  
  // Service Types
  'service.tailor': 'Υπηρεσίες ραπτικής',
  'service.dryCleaning': 'Στεγνό καθάρισμα',
  'service.washing': 'Πλύσιμο',
  'service.ironing': 'Σιδέρωμα',
  'service.shoeShine': 'Καθαρισμός παπουτσιών',
  'service.carpet': 'Χαλί',
  'service.tailoring': 'Επιδιόρθωση ραπτικής',
  'service.carpetWashing': 'Πλύσιμο χαλιών',
  'service.selectService': 'Επιλέξτε υπηρεσία',
  'service.addToCart': 'Προσθήκη στο καλάθι',
  'service.total': 'Σύνολο',
  
  // Order Create Page
  'orderCreate.cart': 'Καλάθι',
  'orderCreate.totalPieces': 'Σύνολο τεμαχίων',
  'orderCreate.plannedDelivery': 'Προγραμματισμένη παράδοση',
  'orderCreate.payment': 'Πληρωμή',
  'orderCreate.save': 'Αποθήκευση',
  'orderCreate.allCategories': 'Όλα',
  'orderCreate.selectCustomer': 'Επιλογή πελάτη',
  'orderCreate.selectCustomerPlaceholder': 'Επιλέξτε πελάτη',
  'orderCreate.change': 'Αλλαγή',
  'orderCreate.select': 'Επιλογή',
  'orderCreate.balance': 'Υπόλοιπο',
  'orderCreate.searchCustomer': 'Αναζήτηση με όνομα, τηλέφωνο ή διεύθυνση... (Παράδειγμα: γιάννης+306912345)',
  'orderCreate.newCustomer': 'Νέος πελάτης',
  'orderCreate.customerName': 'Ονοματεπώνυμο',
  'orderCreate.customerPhone': 'Τηλέφωνο',
  'orderCreate.customerEmail': 'Email',
  'orderCreate.customerAddress': 'Διεύθυνση',
  'orderCreate.addCustomer': 'Προσθήκη πελάτη',
  'orderCreate.customer': 'Πελάτης',
  'orderCreate.serviceType': 'Τύπος υπηρεσίας',
  'orderCreate.clickToSelect': 'Κλικ για επιλογή',
  'orderCreate.deliveryDate': 'Ημερομηνία παράδοσης',
  'orderCreate.details': 'Λεπτομέρειες',
  'orderCreate.itemDetails': 'Λεπτομέρειες προϊόντος',
  'orderCreate.tailoringOperations': 'Εργασίες ραπτικής',
  'orderCreate.tailoringTitle': 'Εργασίες ραπτικής',
  'orderCreate.discount': 'Έκπτωση',
  'orderCreate.discountLabel': 'Έκπτωση (%)',
  'orderCreate.debt': 'Χρέος',
  'orderCreate.credit': 'Πίστωση',
  'orderCreate.homeDelivery': 'Παράδοση κατ\' οίκον',
  'orderCreate.homeDeliveryAddress': 'Διεύθυνση',
  'orderCreate.addressRequired': 'Η διεύθυνση είναι υποχρεωτική!',
  'orderCreate.subtotal': 'Υποσύνολο',
  'orderCreate.grandTotal': 'Γενικό σύνολο',
  
  // Products
  'products.title': 'Ορισμοί προϊόντων',
  'products.addNew': 'Νέο προϊόν',
  'products.category': 'Κατηγορία',
  'products.name': 'Όνομα προϊόντος',
  'products.price': 'Τιμή',
  'products.color': 'Χρώμα',
  'products.active': 'Ενεργό',
  'products.actions': 'Ενέργειες',
  'products.search': 'Αναζήτηση προϊόντος...',
  'products.noProducts': 'Δεν βρέθηκαν προϊόντα',
  'products.noCategoryProducts': 'Δεν βρέθηκαν προϊόντα σε αυτήν την κατηγορία',
  'products.emptyCart': 'Το καλάθι είναι άδειο',
  
  // Customers
  'customers.title': 'Πελάτες',
  'customers.addNew': 'Νέος πελάτης',
  'customers.search': 'Αναζήτηση πελατών...',
  'customers.name': 'Όνομα',
  'customers.phone': 'Τηλέφωνο',
  'customers.email': 'Email',
  'customers.address': 'Διεύθυνση',
  'customers.balance': 'Υπόλοιπο',
  'customers.actions': 'Ενέργειες',
  'customers.edit': 'Επεξεργασία',
  'customers.delete': 'Διαγραφή',
  'customers.noCustomers': 'Δεν βρέθηκαν πελάτες',
  'customers.tableCustomer': 'Πελάτης',
  'customers.tableContact': 'Επικοινωνία',
  'customers.tableAddress': 'Διεύθυνση',
  'customers.tableNotifications': 'Ειδοποιήσεις',
  'customers.tableBalance': 'Υπόλοιπο',
  'customers.tableActions': 'Ενέργειες',
  'customers.totalCount': 'Σύνολο {count} πελάτες',
  'customers.notes': 'Σημείωση',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Αναζήτηση με όνομα, τηλέφωνο, email ή διεύθυνση... (Παράδειγμα: γιάννης+306912345)',
  'customers.updated': 'Ο πελάτης ενημερώθηκε',
  'customers.updateError': 'Ο πελάτης δεν μπορεί να ενημερωθεί',
  'customers.added': 'Ο πελάτης προστέθηκε',
  'customers.addError': 'Ο πελάτης δεν μπορεί να προστεθεί',
  'customers.deleted': 'Ο πελάτης διαγράφηκε',
  'customers.deleteError': 'Ο πελάτης δεν μπορεί να διαγραφεί',
  'customers.deleteConfirm': 'Θέλετε πραγματικά να διαγράψετε τον πελάτη "{name}";',
  'customers.loadError': 'Οι πελάτες δεν μπορούν να φορτωθούν',
  'customers.noResults': 'Δεν βρέθηκαν αποτελέσματα',
  'customers.showingFirst50': 'Εμφάνιση των πρώτων 50 αποτελεσμάτων',
  'customers.totalResults': 'σύνολο',
  
  // Users
  'users.title': 'Χρήστες',
  'users.addNew': 'Νέος χρήστης',
  'users.name': 'Πλήρες όνομα',
  'users.email': 'Email',
  'users.role': 'Ρόλος',
  'users.pin': 'PIN',
  'users.permissions': 'Δικαιώματα',
  'users.allPermissions': 'Όλα τα δικαιώματα',
  'users.permissionCount': '{count} δικαιώματα',
  'users.changePin': 'Αλλαγή PIN',
  'users.edit': 'Επεξεργασία',
  'users.newUser': 'Νέος χρήστης',
  'users.editUser': 'Επεξεργασία χρήστη',
  'users.editingUser': 'Επεξεργασία χρήστη {name}',
  'users.pinCode': 'Κωδικός PIN (4-6 ψηφία)',
  'users.selectRole': 'Επιλέξτε ρόλο',
  'users.patron': 'Ιδιοκτήτης',
  'users.kasiyer': 'Ταμίας',
  'users.sofor': 'Οδηγός',
  'users.changePinTitle': 'Αλλαγή κωδικού PIN',
  'users.newPin': 'Νέος κωδικός PIN',
  'users.confirmPin': 'Επιβεβαίωση PIN',
  'users.pinMismatch': 'Οι κωδικοί PIN δεν ταιριάζουν',
  'users.pinRequired': 'Ο κωδικός PIN είναι υποχρεωτικός',
  'users.pinLength': 'Ο κωδικός PIN πρέπει να είναι 4-6 ψηφία',
  'users.changingPinFor': 'Αλλαγή κωδικού PIN για {name}',
  
  // Pricing Page
  'pricing.title': 'Ορισμοί τιμών',
  'pricing.search': 'Αναζήτηση προϊόντος...',
  'pricing.product': 'Προϊόν',
  'pricing.dryCleaning': 'Στεγνό καθάρισμα',
  'pricing.washing': 'Πλύσιμο',
  'pricing.ironing': 'Σιδέρωμα',
  'pricing.tailoring': 'Επιδιόρθωση ραπτικής',
  'pricing.shoeShine': 'Καθαρισμός παπουτσιών',
  'pricing.action': 'Ενέργεια',
  'pricing.save': 'Αποθήκευση',
  'pricing.saving': 'Αποθήκευση',
  'pricing.pricesSaved': 'Οι τιμές αποθηκεύτηκαν',
  'pricing.pricesSaveError': 'Οι τιμές δεν μπορούν να αποθηκευτούν',
  'pricing.noProducts': 'Δεν βρέθηκαν προϊόντα',
  'pricing.loadError': 'Τα προϊόντα δεν μπορούν να φορτωθούν',
  
  // Tailoring Page
  'tailoring.title': 'Εργασίες ραπτικής',
  'tailoring.addNew': 'Νέα εργασία',
  
  // Attributes Page
  'attributes.title': 'Χαρακτηριστικά προϊόντων',
  'attributes.colors': 'Χρώματα',
  'attributes.stains': 'Τύποι λεκέδων',
  'attributes.damages': 'Τύποι ζημιών',
  'attributes.add': 'Προσθήκη',
  
  // Permissions Page
  'permissions.title': 'Διαχείριση δικαιωμάτων',
  'permissions.subtitle': 'Ορίστε δικαιώματα για τους ρόλους ιδιοκτήτη και ταμία',
  'permissions.about': 'Σχετικά με τη διαχείριση δικαιωμάτων',
  'permissions.patronInfo': '<strong>Ιδιοκτήτης:</strong> Κύριος διαχειριστικός ρόλος με όλα τα δικαιώματα συστήματος.',
  'permissions.cashierInfo': '<strong>Ταμίας:</strong> Ρόλος χρήστη με περιορισμένα δικαιώματα για καθημερινές λειτουργίες.',
  'permissions.saveSuccess': 'Τα δικαιώματα αποθηκεύτηκαν',
  'permissions.saveError': 'Τα δικαιώματα δεν μπορούν να αποθηκευτούν',
  'permissions.patron': 'Ιδιοκτήτης',
  'permissions.cashier': 'Ταμίας',
  'permissions.patronRole': 'Πλήρης διαχειριστική πρόσβαση',
  'permissions.cashierRole': 'Περιορισμένη πρόσβαση χρήστη',
  'permissions.activePermissions': 'Ενεργά δικαιώματα:',
  'permissions.selectAllPatron': 'Επιλογή όλων για ιδιοκτήτη',
  'permissions.deselectAllPatron': 'Αποεπιλογή όλων για ιδιοκτήτη',
  'permissions.selectAllCashier': 'Επιλογή όλων για ταμία',
  'permissions.deselectAllCashier': 'Αποεπιλογή όλων για ταμία',
  'permissions.saving': 'Αποθήκευση...',
  'permissions.permissionList': 'Λίστα δικαιωμάτων',
  'permissions.infoTitle': 'Σχετικά με τη διαχείριση δικαιωμάτων',
  'permissions.infoText1': 'Κύριος διαχειριστικός ρόλος με όλα τα δικαιώματα συστήματος.',
  'permissions.infoText2': 'Ρόλος χρήστη με περιορισμένα δικαιώματα για καθημερινές λειτουργίες.',
  'permissions.infoText3': 'Οι αλλαγές τίθενται σε ισχύ μετά την αποθήκευση.',
  'permissions.infoText4': 'Τα δικαιώματα μπορούν να προσαρμοστούν για κάθε ρόλο.',
  
  // Driver Dashboard Page
  'driver.title': 'Πίνακας ελέγχου οδηγού',
  'driver.todayRevenue': 'Σημερινά έσοδα',
  'driver.totalPieces': 'Σύνολο τεμαχίων',
  'driver.pending': 'Εκκρεμεί',
  'driver.ready': 'Έτοιμα',
  'driver.pickup': 'Παραλαβή',
  'driver.delivery': 'Παράδοση',
  
  // Subscription Page
  'subscription.title': 'Συνδρομή και χρέωση',
  'subscription.invoiceManagement': 'Διαχείριση τιμολογίων',
  
  // Invoices Page
  'invoices.title': 'Διαχείριση τιμολογίων',
  'invoices.subtitle': 'Προβολή και λήψη τιμολογίων συνδρομής',
  
  // Expenses Page
  'expenses.title': 'Καταχώριση εξόδων',
  'expenses.addNew': 'Νέο έξοδο',
  'expenses.total': 'Σύνολο εξόδων',
  'expenses.totalToday': 'Σύνολο σημερινών εξόδων',
  'expenses.deletePermission': 'ℹ️ Η διαγραφή εξόδων επιτρέπεται μόνο στον ρόλο ιδιοκτήτη.',
  'expenses.description': 'Περιγραφή',
  'expenses.amount': 'Ποσό',
  'expenses.category': 'Κατηγορία',
  'expenses.noExpenses': 'Δεν υπάρχουν έξοδα για σήμερα',
  'expenses.newExpense': 'Νέο έξοδο',
  'expenses.descriptionLabel': 'Περιγραφή *',
  'expenses.amountLabel': 'Ποσό (€) *',
  'expenses.categoryLabel': 'Κατηγορία *',
  'expenses.categoryPlaceholder': 'Επιλέξτε κατηγορία...',
  'expenses.deleteTitle': 'Διαγραφή εξόδου',
  'expenses.deleteConfirm': 'Θέλετε πραγματικά να διαγράψετε αυτό το έξοδο;',
  'expenses.descriptionField': 'Περιγραφή:',
  'expenses.categoryField': 'Κατηγορία:',
  'expenses.amountField': 'Ποσό:',
  'expenses.dateField': 'Ημερομηνία:',
  'expenses.cancel': 'Ακύρωση',
  'expenses.yesDelete': 'Ναι, διαγραφή',
  'expenses.deleting': 'Διαγραφή...',
  'expenses.saved': 'Το έξοδο αποθηκεύτηκε',
  'expenses.saveError': 'Το έξοδο δεν μπορεί να αποθηκευτεί',
  'expenses.deleted': 'Το έξοδο διαγράφηκε',
  'expenses.deleteError': 'Το έξοδο δεν μπορεί να διαγραφεί',
  'expenses.loadError': 'Τα έξοδα δεν μπορούν να φορτωθούν',
  'expenses.dateFilter': 'Φίλτρο ημερομηνίας',
  'expenses.showDateFilter': 'Επιλέξτε περίοδο',
  'expenses.startDate': 'Ημερομηνία έναρξης',
  'expenses.endDate': 'Ημερομηνία λήξης',
  'expenses.applyFilter': 'Φιλτράρισμα',
  'expenses.clearFilter': 'Εκκαθάριση',
  'expenses.activeFilter': 'Ενεργό φίλτρο',
  'expenses.filterApplied': 'Το φίλτρο ημερομηνίας εφαρμόστηκε',
  'expenses.filterCleared': 'Το φίλτρο καθαρίστηκε',
  'expenses.selectBothDates': 'Παρακαλώ επιλέξτε ημερομηνία έναρξης και λήξης',
  
  // Delivery List Page
  'deliveryList.title': 'Λίστα παράδοσης',
  'deliveryList.search': 'Αριθμός απόδειξης, όνομα πελάτη ή τηλέφωνο...',
  'deliveryList.all': 'Όλα',
  'deliveryList.pending': 'Εκκρεμεί',
  'deliveryList.ready': 'Έτοιμα',
  'deliveryList.date': 'Ημερομηνία',
  'deliveryList.pieces': 'Τεμάχια',
  'deliveryList.amount': 'Ποσό',
  'deliveryList.readyButton': 'Έτοιμο',
  'deliveryList.receiptButton': 'Απόδειξη',
  'deliveryList.noOrders': 'Δεν βρέθηκαν παραγγελίες',
  'deliveryList.statusUpdated': 'Η παραγγελία σημειώθηκε ως έτοιμη',
  'deliveryList.statusUpdateError': 'Η κατάσταση δεν μπορεί να ενημερωθεί',
  'deliveryList.loadError': 'Οι παραγγελίες δεν μπορούν να φορτωθούν',
  'deliveryList.whatsappSending': '📱 Αποστολή μηνύματος WhatsApp...',
  'deliveryList.smsSent': '📨 Το μήνυμα SMS στάλθηκε',
  
  // Delivery Page
  'deliveryPage.title': 'Παράδοση',
  'deliveryPage.search': 'Αναζήτηση με αριθμό απόδειξης, όνομα, τηλέφωνο ή διεύθυνση...',
  'deliveryPage.pieces': 'Τεμάχια',
  'deliveryPage.amount': 'Ποσό',
  'deliveryPage.payment': 'Πληρωμή',
  'deliveryPage.deliverButton': 'Παράδοση',
  'deliveryPage.noOrdersFound': 'Δεν βρέθηκαν έτοιμες παραγγελίες',
  'deliveryPage.noReadyOrders': 'Δεν υπάρχουν παραγγελίες έτοιμες προς παράδοση',
  'deliveryPage.minSearchLength': 'Εισάγετε τουλάχιστον 3 χαρακτήρες',
  'deliveryPage.paymentDialogTitle': 'Πληρωμή κατά την παράδοση',
  'deliveryPage.ordersLoadError': 'Οι παραγγελίες δεν μπορούν να φορτωθούν',
  'deliveryPage.searchError': 'Η αναζήτηση απέτυχε',
  'deliveryPage.deliverySuccess': 'Η παραγγελία παραδόθηκε με επιτυχία',
  'deliveryPage.deliveryError': 'Η παράδοση απέτυχε',
  'deliveryPage.whatsappSending': '📱 Αποστολή απόδειξης μέσω WhatsApp...',
  'deliveryPage.statusNotReady': 'Η παραγγελία βρέθηκε αλλά δεν είναι έτοιμη προς παράδοση',
  'deliveryPage.statusPending': 'Εκκρεμεί - Παρακαλώ σημειώστε την πρώτα ως έτοιμη στη σελίδα "Λίστα παράδοσης"',
  'deliveryPage.statusDelivered': 'Παραδόθηκε',
  'deliveryPage.statusCancelled': 'Ακυρώθηκε',
  'deliveryPage.receiptDelivered': '✅ *ΠΑΡΑΔΟΘΗΚΕ*',
  
  // Receipt Page
  'receipt.title': 'Απόδειξη και ετικέτα',
  'receipt.customerReceipt': 'Απόδειξη πελάτη',
  'receipt.back': 'Πίσω',
  'receipt.print': 'Εκτύπωση απόδειξης',
  'receipt.whatsappSend': 'Αποστολή WhatsApp',
  'receipt.receiptNumber': 'Αριθμός απόδειξης',
  'receipt.date': 'Ημερομηνία',
  'receipt.time': 'Ώρα',
  'receipt.product': 'Προϊόν',
  'receipt.quantity': 'Ποσότητα',
  'receipt.price': 'Τιμή',
  'receipt.totalPieces': 'Σύνολο τεμαχίων',
  'receipt.subtotal': 'Υποσύνολο',
  'receipt.tax': 'ΦΠΑ',
  'receipt.total': 'ΣΥΝΟΛΟ',
  'receipt.payment': 'Πληρωμή',
  'receipt.plannedDelivery': 'Προγραμματισμένη παράδοση',
  'receipt.notFound': 'Η απόδειξη δεν βρέθηκε',
  'receipt.newOrder': 'Νέα παραγγελία',
  'receipt.search': 'Αναζήτηση και επανεκτύπωση απόδειξης',
  'receipt.searchPlaceholder': 'Αναζήτηση με αριθμό απόδειξης, όνομα πελάτη ή τηλέφωνο...',
  'receipt.searchEmpty': 'Εισάγετε αριθμό απόδειξης ή όνομα πελάτη',
  'receipt.noResults': 'Δεν βρέθηκαν αποτελέσματα',
  'receipt.resultsCount': 'Βρέθηκαν {count} αποτελέσματα',
  'receipt.printButton': 'Εκτύπωση απόδειξης',
  'receipt.products': 'Προϊόντα',
  'receipt.loadError': 'Τα δεδομένα δεν μπορούν να φορτωθούν',
  'receipt.whatsappOpening': 'Άνοιγμα WhatsApp...',
  'receipt.labelPrinting': 'Εκτύπωση ετικέτας {current}/{total}...',
  'receipt.andLabel': 'και ετικέτα',
  'receipt.stain': 'Λεκές',
  'receipt.damage': 'Ζημιά',
  'receipt.taxPercent': 'ΦΠΑ (20%)',
  
  // Payment Methods
  'payment.cash': 'Μετρητά',
  'payment.card': 'Πιστωτική κάρτα (POS)',
  'payment.creditCard': 'Πιστωτική κάρτα',
  'payment.mealCard': 'Κάρτα γευμάτων',
  'payment.onDelivery': 'Κατά την παράδοση',
  'payment.account': 'Λογαριασμός',
  
  // Settings Page
  'settings.title': 'Ρυθμίσεις',
  'settings.general': 'Γενικές ρυθμίσεις',
  'settings.companyName': 'Όνομα εταιρείας',
  'settings.language': 'Γλώσσα',
  'settings.currency': 'Νόμισμα',
  'settings.currencyPosition': 'Θέση νομίσματος',
  'settings.currencyPositionLeft': 'Αριστερά (€100,00)',
  'settings.currencyPositionRight': 'Δεξιά (100,00€)',
  'settings.currencyPositionPreviewLeft': 'Σύμβολο αριστερά',
  'settings.currencyPositionPreviewRight': 'Σύμβολο δεξιά',
  'settings.numberFormat': 'Μορφή αριθμών',
  'settings.currencyFormat': 'Μορφή νομίσματος',
  'settings.showDecimals': 'Εμφάνιση δεκαδικών',
  'settings.showDecimalsDesc': 'Εμφάνιση δεκαδικού μέρους (λεπτά) στις τιμές',
  'settings.dateFormat': 'Μορφή ημερομηνίας',
  'settings.deliveryDays': 'Χρόνος παράδοσης (ημέρες)',
  'settings.workOnSunday': 'Εργασία Κυριακή',
  'settings.defaultServiceType': 'Προεπιλεγμένος τύπος υπηρεσίας',
  'settings.defaultServiceTypeDesc': 'Ο τύπος υπηρεσίας που επιλέγεται αυτόματα κατά το άνοιγμα της οθόνης καταχώρισης προϊόντων',
  'settings.defaultCategory': 'Προεπιλεγμένη κατηγορία',
  'settings.defaultCategoryDesc': 'Η κατηγορία που επιλέγεται αυτόματα κατά το άνοιγμα της οθόνης καταχώρισης προϊόντων',
  'settings.companyLogo': 'Λογότυπο εταιρείας',
  'settings.logoDescription': 'Το λογότυπο θα εμφανίζεται στις αποδείξεις και επάνω αριστερά στο πρόγραμμα. Προτεινόμενο μέγεθος: 200x80px',
  'settings.uploadLogo': 'Μεταφόρτωση λογότυπου',
  'settings.removeLogo': 'Αφαίρεση λογότυπου',
  'settings.noLogo': 'Χωρίς λογότυπο',
  'settings.receiptSettings': 'Ρυθμίσεις απόδειξης',
  'settings.taxRate': 'Φορολογικός συντελεστής (%)',
  'settings.receiptFooterText': 'Κείμενο υποσέλιδου απόδειξης',
  'settings.receiptNote': 'Υποσέλιδο απόδειξης (Σημειώσεις)',
  'settings.socialMedia': 'Μέσα κοινωνικής δικτύωσης και επαφές',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Ιστότοπος',
  'settings.phone': 'Τηλέφωνο',
  'settings.address': 'Διεύθυνση',
  'settings.dangerZone': 'Επικίνδυνη ζώνη',
  'settings.deleteDemoDataWarning': 'Η διαγραφή των δεδομένων επίδειξης θα αφαιρέσει όλες τις εγγραφές πελατών, παραγγελιών, πληρωμών και εξόδων.',
  'settings.productsWillBeKept': 'Οι ορισμοί προϊόντων θα διατηρηθούν.',
  'settings.deleteDemoDataTitle': 'Τα δεδομένα επίδειξης διαγράφονται',
  'settings.deleteDemoDataConfirm': 'Αυτή η ενέργεια δεν μπορεί να αναιρεθεί! Όλες οι εγγραφές πελατών, παραγγελιών, πληρωμών και εξόδων θα διαγραφούν.',
  'settings.areYouSure': 'Θέλετε πραγματικά να συνεχίσετε;',
  'settings.deleting': 'Διαγραφή...',
  'settings.yesDelete': 'Ναι, διαγραφή',
  'settings.deleteDemoData': 'Διαγραφή δεδομένων επίδειξης',
  'settings.save': 'Αποθήκευση',
  'settings.loading': 'Φόρτωση...',
  
  // Toasts
  'toast.settingsSaved': 'Οι ρυθμίσεις αποθηκεύτηκαν',
  'toast.settingsError': 'Οι ρυθμίσεις δεν μπορούν να αποθηκευτούν',
  'toast.settingsLoadError': 'Οι ρυθμίσεις δεν μπορούν να φορτωθούν',
  'toast.logoUploaded': 'Το λογότυπο μεταφορτώθηκε. Μην ξεχάσετε να αποθηκεύσετε!',
  'toast.logoRemoved': 'Το λογότυπο αφαιρέθηκε. Μην ξεχάσετε να αποθηκεύσετε!',
  'toast.logoSizeError': 'Το αρχείο λογότυπου πρέπει να είναι μικρότερο από 500 KB',
  'toast.logoTypeError': 'Μπορούν να μεταφορτωθούν μόνο αρχεία εικόνας',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'Σύνδεση WhatsApp',
  'whatsapp.subtitle': 'Διαχείριση σύνδεσης WhatsApp Business API',
  'whatsapp.connectionStatus': 'Κατάσταση σύνδεσης',
  'whatsapp.disconnected': 'Αποσυνδεδεμένο',
  'whatsapp.notConnectedMessage': 'Ο λογαριασμός σας WhatsApp δεν έχει συνδεθεί ακόμα',
  'whatsapp.connectWithQR': 'Σύνδεση με κωδικό QR',
  'whatsapp.importantInfo': 'Σημαντικές πληροφορίες',
  'whatsapp.info1': '1. Σαρώστε τον κωδικό QR με την εφαρμογή WhatsApp στο τηλέφωνό σας',
  'whatsapp.info2': '2. Μετά τη σύνδεση μπορείτε να στέλνετε αυτόματα μηνύματα',
  'whatsapp.info3': '3. Για αποσύνδεση αποσυνδεθείτε από τις ρυθμίσεις WhatsApp',
  'whatsapp.info4': '4. Ο κωδικός QR ανανεώνεται αυτόματα μετά από 60 δευτερόλεπτα',
  'whatsapp.generateQR': 'Δημιουργία κωδικού QR',
  
  // Common
  'common.yes': 'Ναι',
  'common.no': 'Όχι',
  'common.cancel': 'Ακύρωση',
  'common.confirm': 'Επιβεβαίωση',
  'common.delete': 'Διαγραφή',
  'common.edit': 'Επεξεργασία',
  'common.save': 'Αποθήκευση',
  'common.search': 'Αναζήτηση',
  'common.loading': 'Φόρτωση...',
  'common.noData': 'Δεν υπάρχουν δεδομένα',
  'common.actions': 'Ενέργειες',
  'common.status': 'Κατάσταση',
  'common.date': 'Ημερομηνία',
  'common.time': 'Ώρα',
  'common.total': 'Σύνολο',
  'common.close': 'Κλείσιμο',
  'common.back': 'Πίσω',
  'common.submit': 'Υποβολή',
  'common.create': 'Δημιουργία',
  'common.creating': 'Δημιουργία...',
  'common.later': 'Αργότερα',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  
  // Tickets
  'tickets.title': 'Αιτήματα υποστήριξης',
  'tickets.newTicket': 'Νέο αίτημα',
  'tickets.noTickets': 'Δεν υπάρχουν ακόμα αιτήματα υποστήριξης',
  'tickets.noTicketsDesc': 'Εάν έχετε πρόβλημα, μπορείτε να δημιουργήσετε ένα νέο αίτημα υποστήριξης',
  'tickets.subject': 'Θέμα',
  'tickets.description': 'Περιγραφή',
  'tickets.yourName': 'Το όνομά σας',
  'tickets.yourNamePlaceholder': 'Εισάγετε το όνομά σας',
  'tickets.subjectPlaceholder': 'Συνοψίστε το πρόβλημά σας εν συντομία',
  'tickets.descriptionPlaceholder': 'Περιγράψτε το πρόβλημά σας λεπτομερώς',
  'tickets.created': 'Το αίτημα υποστήριξης δημιουργήθηκε',
  'tickets.createError': 'Το αίτημα υποστήριξης δεν μπορεί να δημιουργηθεί',
  'tickets.fillAllFields': 'Συμπληρώστε όλα τα πεδία',
  'tickets.loadError': 'Τα αιτήματα δεν μπορούν να φορτωθούν',
  'tickets.messages': 'Μηνύματα',
  'tickets.status.open': 'Ανοιχτό',
  'tickets.status.investigating': 'Σε επεξεργασία',
  'tickets.status.waitingCustomer': 'Αναμονή πελάτη',
  'tickets.status.closed': 'Επιλύθηκε',
  'tickets.conversation': 'Συνομιλία',
  'tickets.admin': 'Ομάδα υποστήριξης',
  'tickets.typeMessage': 'Πληκτρολογήστε το μήνυμά σας...',
  'tickets.sendError': 'Το μήνυμα δεν μπορεί να σταλεί',
  'tickets.closedMessage': 'Αυτό το αίτημα έχει σημειωθεί ως επιλυμένο.',
  'tickets.rateSupport': 'Αξιολογήστε την υποστήριξη',
  'tickets.rateExperience': 'Αξιολογήστε την εμπειρία σας',
  'tickets.rateDescription': 'Πώς θα αξιολογούσατε την υποστήριξη που λάβατε;',
  'tickets.selectRating': 'Παρακαλώ επιλέξτε βαθμολογία',
  'tickets.ratingSubmitted': 'Η βαθμολογία σας αποθηκεύτηκε, ευχαριστούμε!',
  'tickets.ratingError': 'Η βαθμολογία δεν μπορεί να σταλεί',
  'tickets.yourRating': 'Η βαθμολογία σας',
  'tickets.rating.veryBad': 'Πολύ κακή',
  'tickets.rating.bad': 'Κακή',
  'tickets.rating.okay': 'Καλή',
  'tickets.rating.good': 'Πολύ καλή',
  'tickets.rating.excellent': 'Εξαιρετική',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Σύστημα διαχείρισης χημικού καθαρισμού',
  'login.tenantId': 'ID εταιρείας',
  'login.tenantPlaceholder': 'id-εταιρείας (π.χ.: acme-clean)',
  'login.tenantIdHelp': 'Εισάγετε το μοναδικό αναγνωριστικό της εταιρείας σας',
  'login.continue': 'Συνέχεια →',
  'login.notMember': 'Δεν είστε ακόμα μέλος;',
  'login.startTrial': 'Ξεκινήστε δωρεάν δοκιμή',
  'login.adminLogin': '🔒 Σύνδεση διαχειριστή',
  'login.enterPin': 'Εισάγετε τον κωδικό PIN σας',
  'login.changeTenant': 'Αλλαγή εταιρείας',
  'login.clear': 'Εκκαθάριση',
  'login.delete': 'Διαγραφή',
  'login.login': 'Σύνδεση',
  'login.loggingIn': 'Σύνδεση...',
  'login.defaultPinOwner': 'Προεπιλεγμένος PIN: <strong>1234</strong> (Ιδιοκτήτης)',
  'login.defaultPinCashier': 'Προεπιλεγμένος PIN: <strong>0000</strong> (Ταμίας)',
  'login.systemInitializing': 'Το σύστημα αρχικοποιείται...',
  'login.pinMinLength': 'Ο PIN πρέπει να είναι τουλάχιστον 4 ψηφία',
  'login.invalidTenantId': 'Εισάγετε έγκυρο ID εταιρείας',
  'login.tenantNotFound': 'Αυτός ο κωδικός εταιρείας δεν βρέθηκε. Παρακαλώ ελέγξτε ή δημιουργήστε νέο λογαριασμό.',
  'login.loginFailed': 'Η σύνδεση απέτυχε',
  'login.welcome': 'Καλώς ήρθατε, {name}',
  'login.tagline': 'Λογισμικό στεγνού καθαρισμού — Έξυπνες και εύκολες λύσεις για την επιχείρησή σας',

  // Signup translations
  'signup.title': 'Ξεκινήστε δωρεάν δοκιμή',
  'signup.subtitle': '15 ημέρες δωρεάν, δεν απαιτείται πιστωτική κάρτα',
  'signup.backToLogin': 'Επιστροφή στη σύνδεση',
  'signup.companyCode': 'Κωδικός εταιρείας',
  'signup.companyCodePlaceholder': 'π.χ.: cleanpro',
  'signup.companyCodeHelp': 'Αυτός ο κωδικός θα χρησιμοποιηθεί για σύνδεση στο σύστημα',
  'signup.companyCodeMinLength': 'Ο κωδικός εταιρείας πρέπει να είναι τουλάχιστον 3 χαρακτήρες',
  'signup.companyName': 'Όνομα εταιρείας',
  'signup.companyNamePlaceholder': 'Το όνομα της εταιρείας σας',
  'signup.companyNameRequired': 'Το όνομα εταιρείας είναι υποχρεωτικό',
  'signup.fullName': 'Πλήρες όνομα',
  'signup.fullNamePlaceholder': 'Το πλήρες όνομά σας',
  'signup.fullNameRequired': 'Το πλήρες όνομα είναι υποχρεωτικό',
  'signup.phone': 'Τηλέφωνο',
  'signup.phonePlaceholder': '+30 69 1234 5678',
  'signup.validPhoneRequired': 'Παρακαλώ εισάγετε έγκυρο αριθμό τηλεφώνου',
  'signup.email': 'Email',
  'signup.emailPlaceholder': 'example@company.gr',
  'signup.validEmailRequired': 'Παρακαλώ εισάγετε έγκυρη διεύθυνση email',
  'signup.createAccount': 'Δημιουργία λογαριασμού',
  'signup.creating': 'Δημιουργία...',
  'signup.terms': 'Δημιουργώντας λογαριασμό, συμφωνείτε με τους Όρους Χρήσης και την Πολιτική Απορρήτου μας.',
  'signup.success': 'Η εγγραφή ολοκληρώθηκε! Τα στοιχεία σύνδεσης στάλθηκαν στο email σας.',
  'signup.successTitle': 'Η εγγραφή ολοκληρώθηκε!',
  'signup.successMessage': 'Ο λογαριασμός σας δημιουργήθηκε με επιτυχία.',
  'signup.emailSent': 'Τα στοιχεία σύνδεσης στάλθηκαν στο email σας.',
  'signup.redirecting': 'Ανακατεύθυνση στη σελίδα σύνδεσης...',
  'signup.startupPackageLoaded': 'Το πακέτο εκκίνησης φορτώθηκε!',
  'signup.products': 'Προϊόν',
  'signup.customers': 'Πελάτης',
  'signup.users': 'Χρήστης',
  'signup.demoDataReady': '✨ Τα δεδομένα επίδειξής σας είναι έτοιμα, μπορείτε να ξεκινήσετε αμέσως!',
  'signup.loginInfo': '📧 Τα στοιχεία σύνδεσής σας',
  'signup.loginInfoSent': '💡 Αυτά τα στοιχεία σύνδεσης στάλθηκαν επίσης στο email σας',
  'signup.loginNow': 'Συνδεθείτε τώρα →',
  
  // Account Statement Page
  'accountStatement.title': 'Κατάσταση λογαριασμού',
  'accountStatement.subtitle': 'Παρακολούθηση εισπρακτέων ανά πελάτη',
  'accountStatement.selectCustomer': 'Επιλογή πελάτη',
  'accountStatement.customerPlaceholder': 'Επιλέξτε πελάτη...',
  'accountStatement.searchCustomer': 'Αναζήτηση με όνομα, τηλέφωνο ή διεύθυνση...',
  'accountStatement.noCustomerSelected': 'Παρακαλώ επιλέξτε πελάτη',
  'accountStatement.currentBalance': 'Τρέχον υπόλοιπο',
  'accountStatement.totalDebt': 'Συνολικό χρέος',
  'accountStatement.totalPayments': 'Συνολικές πληρωμές',
  'accountStatement.transactions': 'Συναλλαγές',
  'accountStatement.noTransactions': 'Δεν βρέθηκαν εγγραφές συναλλαγών για αυτόν τον πελάτη',
  'accountStatement.date': 'Ημερομηνία',
  'accountStatement.description': 'Περιγραφή',
  'accountStatement.debit': 'Χρέωση',
  'accountStatement.credit': 'Πίστωση',
  'accountStatement.balance': 'Υπόλοιπο',
  'accountStatement.order': 'Παραγγελία',
  'accountStatement.payment': 'Πληρωμή',
  'accountStatement.loadError': 'Η κατάσταση λογαριασμού δεν μπορεί να φορτωθεί',
  'accountStatement.addPayment': 'Προσθήκη πληρωμής',
  'accountStatement.paymentAmount': 'Ποσό πληρωμής',
  'accountStatement.paymentMethod': 'Μέθοδος πληρωμής',
  'accountStatement.paymentNotes': 'Σημειώσεις (προαιρετικό)',
  'accountStatement.recordPayment': 'Καταχώριση πληρωμής',
  'accountStatement.paymentSaved': 'Η πληρωμή καταχωρίστηκε',
  'accountStatement.paymentError': 'Η πληρωμή δεν μπορεί να καταχωριστεί',
  'accountStatement.selectCustomerFirst': 'Παρακαλώ επιλέξτε πρώτα πελάτη',
  'accountStatement.exportStatement': 'Εξαγωγή κατάστασης',
  'accountStatement.exportStatementPDF': 'Λήψη PDF',
  'accountStatement.noCustomersFound': 'Δεν βρέθηκαν πελάτες',
  'accountStatement.searchHint': 'Εισάγετε τουλάχιστον 2 χαρακτήρες για αναζήτηση πελατών',
  'accountStatement.selectedCustomer': 'Επιλεγμένος πελάτης',
  'accountStatement.changeCustomer': 'Αλλαγή πελάτη',
  
  // Toast Messages
  'toast.usernameRequired': 'Το όνομα χρήστη είναι υποχρεωτικό',
  'toast.firstLoginChangePin': '⚠️ Πρώτη σύνδεση - Παρακαλώ αλλάξτε τον κωδικό PIN σας',
  'toast.tenantNotFound': 'Η εταιρεία δεν βρέθηκε: "{tenantId}"\\n\\nΠαρακαλώ κάντε κλικ στο "Ξεκινήστε δωρεάν δοκιμή" για να δημιουργήσετε νέο λογαριασμό εταιρείας.',
  'toast.tenantIdNotRemembered': '🗑️ Το ID εταιρείας δεν θα απομνημονευτεί',
  'toast.demoDataLoaded': 'Δημιουργήθηκαν δοκιμαστικοί χρήστες, προϊόντα, πελάτες και παραγγελίες!',
  
  'toast.productsLoadError': 'Σφάλμα φόρτωσης προϊόντων',
  'toast.statsLoadError': 'Σφάλμα φόρτωσης στατιστικών',
  'toast.deliveryBeforeToday': 'Η ημερομηνία παράδοσης δεν μπορεί να είναι πριν από σήμερα',
  'toast.customerOpenOrders': 'Ο πελάτης έχει {count} ανοιχτές παραγγελίες',
  'toast.customerDebt': 'Ο πελάτης έχει χρέος {amount}',
  'toast.customerSaved': 'Ο πελάτης αποθηκεύτηκε',
  'toast.customerSaveError': 'Σφάλμα αποθήκευσης πελάτη',
  'toast.customerUpdated': 'Ο πελάτης ενημερώθηκε',
  'toast.customerUpdateError': 'Σφάλμα ενημέρωσης πελάτη',
  'toast.productAddedToCart': 'Το προϊόν προστέθηκε στο καλάθι',
  'toast.enterValidArea': 'Παρακαλώ εισάγετε έγκυρο εμβαδόν',
  'toast.carpetsAddedToCart': '{count} χαλιά προστέθηκαν στο καλάθι ({area} m² x {price}/m²)',
  'toast.carpetAddedToCart': 'Το χαλί προστέθηκε στο καλάθι ({area} m² x {price}/m²)',
  'toast.selectAtLeastOneService': 'Παρακαλώ επιλέξτε τουλάχιστον μία υπηρεσία',
  'toast.productAdded': 'Το προϊόν προστέθηκε',
  'toast.productDetailsUpdated': 'Οι λεπτομέρειες του προϊόντος ενημερώθηκαν',
  'toast.priceUpdated': 'Η τιμή ενημερώθηκε',
  'toast.fillAllCardInfo': 'Παρακαλώ συμπληρώστε όλα τα στοιχεία της κάρτας',
  'toast.invalidCardNumber': 'Μη έγκυρος αριθμός κάρτας',
  'toast.invalidMonth': 'Μη έγκυρος μήνας (πρέπει να είναι μεταξύ 1-12)',
  'toast.invalidYear': 'Μη έγκυρο έτος',
  'toast.invalidCvc': 'Μη έγκυρο CVC',
  'toast.cardPaymentSuccess': 'Η πληρωμή με κάρτα ήταν επιτυχής!',
  'toast.cardPaymentError': 'Η πληρωμή με κάρτα απέτυχε',
  'toast.paymentFailed': 'Η πληρωμή απέτυχε. Παρακαλώ δοκιμάστε ξανά.',
  'toast.paymentStatusCheckError': 'Σφάλμα ελέγχου κατάστασης πληρωμής. Παρακαλώ ελέγξτε τον λογαριασμό σας.',
  'toast.selectCustomer': 'Παρακαλώ επιλέξτε πελάτη',
  'toast.addProduct': 'Παρακαλώ προσθέστε προϊόν',
  'toast.addressRequiredForDelivery': 'Για παράδοση κατ\' οίκον απαιτείται διεύθυνση πελάτη. Παρακαλώ προσθέστε διεύθυνση.',
  'toast.orderSaved': 'Η παραγγελία αποθηκεύτηκε',
  'toast.orderSaveError': 'Σφάλμα αποθήκευσης παραγγελίας',
  'toast.enterValidValue': 'Εισάγετε έγκυρη τιμή (0-100)',
  'toast.enterValidAmount': 'Εισάγετε έγκυρο ποσό',
  'toast.amountExceedsRemaining': 'Το ποσό δεν μπορεί να υπερβαίνει το υπόλοιπο',
  'toast.selectPaymentMethodFirst': 'Επιλέξτε πρώτα μέθοδο πληρωμής και εισάγετε ποσό',
  'toast.selectAtLeastOneOperation': 'Παρακαλώ επιλέξτε τουλάχιστον μία εργασία',
  'toast.tailorAddedToCart': 'Η εργασία ραπτικής προστέθηκε στο καλάθι',
  
  'toast.receiptCopied': '📋 Η απόδειξη αντιγράφηκε! Επιλέξτε επαφή στο WhatsApp Web και επικολλήστε (Ctrl+V)',
  'toast.autoCopyFailed': '⚠️ Η αυτόματη αντιγραφή απέτυχε. Παρακαλώ αντιγράψτε χειροκίνητα από την προεπισκόπηση.',
  'toast.printingLabel': 'Εκτύπωση ετικέτας {current}/{total}...',
  'toast.markedAsReady': '✅ Η παραγγελία σημειώθηκε ως έτοιμη',
  'toast.messageCopied': '📋 Το μήνυμα αντιγράφηκε! Επικολλήστε στο WhatsApp (Ctrl+V)',
  'toast.whatsappSending': 'Αποστολή μηνύματος WhatsApp...',
  'toast.readyMarkError': 'Σφάλμα σήμανσης ως έτοιμο',
  'toast.markedAsDelivered': '✅ Η παραγγελία σημειώθηκε ως παραδοθείσα',
  'toast.deliveredMarkError': 'Σφάλμα σήμανσης ως παραδοθείσας',
  'toast.copyFailed': '⚠️ Η αντιγραφή απέτυχε. Επιλέξτε το κείμενο και πατήστε Ctrl+C',
  'toast.textSelected': '✅ Το κείμενο επιλέχθηκε! Αντιγράψτε με Ctrl+C',
  'toast.textSelectFailed': 'Το κείμενο δεν μπορεί να επιλεγεί',
  'toast.statusUpdated': 'Η κατάσταση ενημερώθηκε',
  'toast.smsSent': 'Το SMS στάλθηκε',
  'toast.statusUpdateError': 'Σφάλμα ενημέρωσης κατάστασης',
  'toast.cancelReasonRequired': 'Ο λόγος ακύρωσης είναι υποχρεωτικός',
  'toast.orderCancelled': 'Η παραγγελία ακυρώθηκε',
  'toast.cancelError': 'Σφάλμα ακύρωσης',
  'toast.deliverySuccess': 'Η παράδοση ήταν επιτυχής',
  'toast.deliveryError': 'Σφάλμα παράδοσης',
  'toast.orderSetToReady': 'Η παραγγελία σημειώθηκε ως έτοιμη',
  
  'toast.tenantIdNotFound': 'Το ID μισθωτή δεν βρέθηκε',
  'toast.demoProductsLoaded': 'Τα δοκιμαστικά προϊόντα φορτώθηκαν!',
  'toast.productsAddError': 'Σφάλμα προσθήκης προϊόντων',
  'toast.englishNamesMigration': 'Προστέθηκαν αγγλικά ονόματα σε {count} προϊόντα',
  'toast.migrationFailed': 'Η μετάβαση απέτυχε',
  'toast.multiLanguageConversion': '✅ {count} προϊόντα μετατράπηκαν σε πολυγλωσσική μορφή!',
  'toast.multiLanguageConversionError': 'Σφάλμα πολυγλωσσικής μετατροπής',
  'toast.productNameRequired': 'Το όνομα προϊόντος είναι υποχρεωτικό',
  'toast.productUpdated': 'Το προϊόν ενημερώθηκε',
  'toast.productDeleted': 'Το προϊόν διαγράφηκε',
  'toast.productDeleteError': 'Σφάλμα διαγραφής προϊόντος',
  
  'toast.whatsappNotInStarter': '⚠️ Η λειτουργία WhatsApp δεν είναι διαθέσιμη στο πλάνο Starter. Μπορείτε να αναβαθμίσετε σε Professional ή Enterprise.',
  'toast.schemaError': '⚠️ Το σχήμα βάσης δεδομένων δεν υπάρχει!\\n\\nΡυθμίσεις → "🗄️ Φόρτωση σχήματος" → Εκτελέστε στο Supabase SQL Editor',
  
  // Order Page
  'order.deliveryDate': 'Ημερομηνία παράδοσης',
  'order.notes': 'Σημειώσεις',
  'order.createOrder': 'Δημιουργία παραγγελίας',
  'order.cancel': 'Ακύρωση',
  'order.discountRate': 'Έκπτωση',
  'order.discountPercent': 'Έκπτωση ({percent}%)',
  'order.discountOptional': 'Έκπτωση (προαιρετική)',
  'order.enterDiscountRate': 'Εισάγετε ποσοστό έκπτωσης (0-100):',
  'order.quickDiscount': 'Κουμπιά γρήγορης έκπτωσης',
  'order.discountSummary': 'Σύνοψη εκπτώσεων',
  'order.debt': 'Χρέος',
  'order.receivable': 'Εισπρακτέο',
  'order.balanced': 'Ισοσκελισμένο',
  'order.totalDebt': 'Συνολικό χρέος',
  'order.totalPayments': 'Συνολικές πληρωμές',
  'order.homeDeliveryShort': 'Παράδοση κατ\' οίκον',
  'order.homeDeliveryIcon': '🏠 Παράδοση κατ\' οίκον',
  'order.addressIcon': '📍 Διεύθυνση',
  'order.addressRequiredForDelivery': 'Για παράδοση κατ\' οίκον απαιτείται διεύθυνση',
  'order.priceAndDiscountEdit': 'Επεξεργασία τιμής και έκπτωσης',
  'order.discount': 'Έκπτωση',
  'order.subtotal': 'Υποσύνολο',
  'order.tax': 'ΦΠΑ',
  'order.grandTotal': 'Γενικό σύνολο',
  'order.payment': 'Πληρωμή',
  'order.paymentMethod': 'Μέθοδος πληρωμής',
  'order.cash': 'Μετρητά',
  'order.card': 'Πιστωτική κάρτα',
  'order.credit': 'Πίστωση',
  'order.amountPaid': 'Ποσό που πληρώθηκε',
  'order.remainingBalance': 'Υπόλοιπο',
};
